import { createContext } from "react";
const VTradingContext = createContext();
export default VTradingContext;
